import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { gql, request, type Variables } from 'graphql-request';

import { getGraphQlEndpoint } from '@/api/backendAPI';
import useCurrency from '@/app/hooks/useCurrency';

import type {
  GetOneDiscount,
  GetOneDiscount_content,
  GetOneDiscountVariables,
} from './types/GetOneDiscount';

export const query = gql`
  query GetOneDiscount($discountCode: String!, $currencyCode: String) {
    content(currency: $currencyCode) {
      discount(discountCode: $discountCode) {
        valid
        invalidReason
        id: discountId
        title
        discountCodes
        appliesTo
        campaign
        grantFreeShipping
        grantSubscription
        usageLimit
        usageCount
        defaultPdpUrl
        priceRules {
          categories
          productKeys
        }
      }
    }
  }
`;

export function withQueryKey(req: GetOneDiscountVariables) {
  return {
    queryKey: ['fetchDiscount', req.discountCode, req.currencyCode],
    queryFn: async () => {
      const url = getGraphQlEndpoint()!;
      const data: GetOneDiscount = await request(
        url,
        query,
        req as unknown as Variables,
      );
      const discountData = data.content?.discount;

      return { discount: discountData };
    },
  };
}

export function useDiscount(
  discountCode: GetOneDiscountVariables['discountCode'],
): UseQueryResult<GetOneDiscount_content> {
  const { currencyCode } = useCurrency();

  return useQuery({
    ...withQueryKey({
      discountCode,
      currencyCode,
    }),
    enabled: !!discountCode,
  });
}
